import React from "react";
import ContentContainer from "../Components/ContentContainer.tsx";
import "./HeartyEarth.css";
import logoSolid from "../assets/logo-solid.svg";
import HashtagGrid from "../Components/HashtagGrid.tsx";
import facebookIcon from "../assets/facebook.svg";
import HashtagCarousel from "../Components/HashtagCarousel.tsx";
import LatestBlogPost from "../Components/Contentful/LatestBlogPost.tsx";

function HeartyEarth() {
  return (
    <>
      <ContentContainer
        showcase={true}
        children={
          <>
            <div className="row align-items-start we-are-row">
              <div className="col-auto">
                <h1 className="we-are-span">We are </h1>
              </div>
              <div className="col me-auto">
                <HashtagCarousel />
              </div>
            </div>

            <div className="row">
              <hr />
            </div>

            <div className="row">
              <div className="column">
                <p>
                  At <span className="hashtag-small">#HeartyEarth</span> it is
                  our mission to encourage people to{" "}
                  <span className="hashtag-small">#BeTheChange</span> they want
                  to see — To{" "}
                  <span className="hashtag-small">#AspireToInspire</span>, to{" "}
                  <span className="hashtag-small">#ShareTheLove</span>,{" "}
                  <span className="hashtag-small">#InspireInclusion</span>, and
                  so much more.
                </p>
                <p>
                  Our goal is to help people recognise compassion in themselves
                  and those around them and to understand how they can utilise
                  it to support their communities.
                </p>
              </div>
            </div>

            <div className="row align-items-center justify-content-center">
              <div className="col-auto">
                <div className="moving-badge">
                  <img src={logoSolid} alt="badge" />
                </div>
              </div>
              <div className="col">
                <div className="row">
                  <p>
                    Our badges show recognition for the great work people do.
                  </p>
                  <p>Think you've earnt one? Let us know what for!</p>
                </div>
                <div className="row button-row" style={{ marginTop: "2rem" }}>
                  <div className="col-auto center-500">
                    <button
                      className="gold"
                      onClick={() =>
                        window.open(
                          "https://settleup.starlingbank.com/samanjamshidifard?amount=5.00&message=Support%20%23HeartEarth%20initiatives%20",
                          "_blank"
                        )
                      }
                    >
                      Get a badge
                      <i className="material-icons md-24 icon">
                        volunteer_activism
                      </i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <hr />
            </div>

            <div className="row button-row">
              <div className="col-auto center-500">
                <button
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/OxfordCityLarder?locale=en_GB",
                      "_blank"
                    )
                  }
                >
                  Discover our work!
                  <img
                    src={facebookIcon}
                    alt="facebook-icon"
                    className="icon md-32 outlined"
                  />
                </button>
              </div>
            </div>
          </>
        }
      />

      <LatestBlogPost />

      <ContentContainer
        children={
          <>
            <div className="row">
              <div className="col-auto">
                <h1>Why hashtags?</h1>
              </div>
            </div>

            <div className="row">
              <p>
                Put simply, what better tool is there for sharing content with
                everyone at once?
                <br />
                <br />
                Hashtags provide an incredible way to spread our message
                inclusively and without pressure. They allow us to reach the
                masses on their terms!
              </p>
            </div>

            <div className="row">
              <p>Click any below to see what we're about!</p>
            </div>

            <div className="row">
              <HashtagGrid />
            </div>
          </>
        }
      />
    </>
  );
}

export default HeartyEarth;
